'use client';

import { useState } from 'react';

import { Main } from '@ui/sections/main/Main';
import { useCurrentUser } from '@website/hooks/useCurrentUser';
import { useSearchPosition } from '@website/hooks/useSearchPosition';

import { SearchFilters } from '../../../../components/SearchFilters';
import { ViewToggleFloatingButton } from '../../../../components/ViewToggleFloatingButton';
import ActivitiesListWrapper from './ActivitiesListWrapper';

interface ClientWrapperProps {
  categoryItems: Array<{ id: string; name: string }>;
}

export default function ClientWrapper({ categoryItems }: ClientWrapperProps) {
  const { data: user } = useCurrentUser();
  const [isMapDisplayMode, setIsMapDisplayMode] = useState(false);
  const [selectedActivityId, setSelectedActivityId] = useState<string | undefined>(undefined);
  const [selectionSource, setSelectionSource] = useState<'map' | 'list' | null>(null);
  const [isLocationPickerOpen, setIsLocationPickerOpen] = useState(false);
  const position = useSearchPosition();

  const toggleViewMode = () => {
    setSelectedActivityId(undefined);
    setSelectionSource(null);
    setIsMapDisplayMode((prev) => !prev);
  };

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <Main className="flex flex-col flex-1 min-h-0 relative w-full">
        <div className="flex-shrink-0 z-30 bg-white py-2 border-b border-neutral-200">
          <SearchFilters
            className="layout-bounds"
            categories={categoryItems}
            setLocation={position.setLocation}
            onLocationPickerOpenChange={setIsLocationPickerOpen}
          />
        </div>
        <div className="relative flex-1 min-h-0 overflow-y-auto">
          <ActivitiesListWrapper
            isMapDisplayMode={isMapDisplayMode}
            selectedActivityId={selectedActivityId}
            setSelectedActivityId={setSelectedActivityId}
            selectionSource={selectionSource}
            setSelectionSource={setSelectionSource}
            user={user ?? null}
            mapBounds={position.mapBounds}
            handleMapIdle={position.handleMapIdle}
            center={position.center}
            zoom={position.zoom}
            panVersion={position.panVersion}
            setLocation={position.setLocation}
          />
        </div>
        {!isLocationPickerOpen && (
          <ViewToggleFloatingButton isMapDisplayMode={isMapDisplayMode} toggleViewMode={toggleViewMode} />
        )}
      </Main>
    </div>
  );
}
